export const environment = {
  production: false,
  backendUrl: "https://cms.kotha.com.bd",
  apiKey: "BkHHF2wtiFvfEGa7Oa2c4IY0kE1nW7Dh",
  brandKey: "BDCOM_IPTSP",
  userId: "system_api",
};
